import { Link, Text, View } from '@react-pdf/renderer'
import { fmtPhoneNumber } from '~/lib'
import type { Client, Listing } from '~/models'
import { tw } from './tw'

export default function PdfListingBrokers({
  listing,
  client,
}: {
  listing: Listing
  client: Client
}) {
  return (
    <View style={tw('mt-4')} break>
      {client.contact && (
        <>
          <Text style={tw('font-heading mb-4 text-lg leading-none')}>
            Economic Development Contact
          </Text>
          <View
            key={client.contact.name}
            style={tw('mb-4 flex flex-col gap-2')}>
            <View style={tw('flex flex-row items-start gap-4')}>
              <View style={tw('flex flex-col gap-1')}>
                <View style={tw('flex flex-row')}>
                  <Text style={tw('text-base font-medium')}>
                    {client.contact.name}
                  </Text>
                </View>
                {client.contact.title && (
                  <Text style={tw('text-sm text-muted')}>
                    {client.contact.title}
                  </Text>
                )}
                {client.contact.email && (
                  <View style={tw('mt-1 flex flex-row')}>
                    <Text style={tw('w-4 text-sm')}>E:</Text>
                    <Link
                      style={tw('text-sm text-primary no-underline')}
                      href={`mailto:${client.contact.email}`}>
                      {client.contact.email}
                    </Link>
                  </View>
                )}
                {client.contact.phone && (
                  <View style={tw('mt-1 flex flex-row')}>
                    <Text style={tw('w-4 text-sm')}>M:</Text>
                    <Link
                      style={tw('text-sm text-primary no-underline')}
                      href={`tel:${client.contact.phone}`}>
                      {fmtPhoneNumber(client.contact.phone)}
                    </Link>
                  </View>
                )}
              </View>
            </View>
          </View>
        </>
      )}
      <Text style={tw('font-heading mb-4 mt-2 text-lg leading-none')}>
        {listing.organization.name}
      </Text>
      {listing.profiles.map((broker) => {
        return (
          <View key={broker.id} style={tw('mb-4 flex flex-col gap-2')}>
            <View style={tw('flex flex-row items-start gap-4')}>
              <View style={tw('flex flex-col gap-1')}>
                <View style={tw('flex flex-row')}>
                  <Text style={tw('text-base font-medium')}>
                    {`${broker.first_name} ${broker.last_name}`}
                  </Text>
                </View>
                {broker.title && (
                  <Text style={tw('text-sm text-muted')}>{broker.title}</Text>
                )}
                {broker.email && (
                  <View style={tw('mt-1 flex flex-row')}>
                    <Text style={tw('w-4 text-sm')}>E:</Text>
                    <Link
                      style={tw('text-sm text-primary no-underline')}
                      href={`mailto:${broker.email}`}>
                      {broker.email}
                    </Link>
                  </View>
                )}
                {broker.office && (
                  <View style={tw('mt-1 flex flex-row')}>
                    <Text style={tw('w-4 text-sm')}>O:</Text>
                    <Link
                      style={tw('text-sm text-primary no-underline')}
                      href={`tel:${broker.office}`}>
                      {fmtPhoneNumber(broker.office)}
                    </Link>
                  </View>
                )}
                {broker.mobile && (
                  <View style={tw('mt-1 flex flex-row')}>
                    <Text style={tw('w-4 text-sm')}>M:</Text>
                    <Link
                      style={tw('text-sm text-primary no-underline')}
                      href={`tel:${broker.mobile}`}>
                      {fmtPhoneNumber(broker.mobile)}
                    </Link>
                  </View>
                )}
              </View>
            </View>
          </View>
        )
      })}
    </View>
  )
}
